import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common'
import { z } from 'zod'

export const Inv4310SearchParamsSchema = z
  .object({
    partyId: z.union([z.number(), z.string()]).optional(),
    itemId: z.union([z.number(), z.string()]).optional(),
    showOnlyOutstanding: z.boolean().optional().default(true),
  })
  .merge(BasePaginateParamsSchema)

export type Inv4310SearchParams = z.infer<typeof Inv4310SearchParamsSchema>

export const Inv4310SearchResultModelSchema = z.object({
  id: z.number(),
  itemId: z.number(),
  lotNo: z.string(),
  mold: z.string(),
  partyId: z.number().nullable(),
  totalRejectedQty: z.number(),
  totalReturnedQty: z.number(),
  totalClaimReceivedQty: z.number(),
  needToReturnQty: z.number(),
  needToReceiveQty: z.number(),
})

export type Inv4310SearchResultModel = z.infer<
  typeof Inv4310SearchResultModelSchema
>

export const Inv4310SearchResultSchema = z
  .object({
    data: z.array(Inv4310SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Inv4310SearchResult = z.infer<typeof Inv4310SearchResultSchema>
